import React, { Component } from 'react';

export default class ReviewsAggMetadata extends Component {
  componentDidMount() {
    this.props.fetchReviewStatsIfNeeded();
  }

  render() {
    const { itemName, stats } = this.props;
    const scriptTag = `
<script type="application/ld+json">
  {
    "@context": "http://schema.org/",
    "@type": "AggregateRating",
    "itemReviewed": {
      "@type": "Product",
      "name": "${itemName || "Logo design, graphic design, web design, product design and company naming"}",
      "aggregateRating": {
        "ratingValue": "${stats.avg}",
        "reviewCount": ${stats.count}
      }
    },
    "ratingValue": "${stats.avg}",
    "reviewCount": ${stats.count}
  };
</script>
`;

    return <span dangerouslySetInnerHTML={{ __html: scriptTag }} />;
  }
}



// WEBPACK FOOTER //
// ./marketing/components/reviews_agg_metadata.jsx